"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["#D73450", "#EC722E", "#F1BB40", "#94D9B7", "#61CC8A", "#9DD0F8", "#4292DD", "#E893A7", "#8B28E6"];
